import React from 'react';
import { Modal, Input, Select, notification, Button } from 'antd';
import { post } from '../../utils/http'
import api from '../../utils/api'
import _ from 'lodash';
import { sessionManager } from '../../core/SessionManager';

const { Option } = Select;
const { confirm } = Modal;

export default function ValidPassword(props) {
    const [password, setPassword] = React.useState('');

    const handleSubmit = () => {//submit button

        props.closeModal()
        // setConfirmLoading(true)
        // const createData = { username: username, email: email, detailId:sessionManager.getMerchantId() }
        // post(api.saveAndUpdateUser, createData).then(function (response) {
        //     notification['success']({
        //         message: 'Create successfully.',
        //     });
        //     props.closeCreateModal()
        //     props.handleSearch()
        //     setConfirmLoading(false)
        // }).catch(function (error) {
        //     notification['error']({
        //         message: error,
        //     });
        //     setConfirmLoading(false)
        // })
    }

    return (
        <>
            <Modal
                destroyOnClose={true}
                title="Refund"
                visible={props.isOpenModal}
                onOk={handleSubmit}
            >
                <div>
                    {/* <div style={{ width: "320px" }}>
                        <Input placeholder="Registered Mobile No (e.g. 6512345678)" onChange={event => setPassword(event.target.value)} style={{ height: "36px", width: "320px" }} />
                        <Button>SEND ME OTP NOW</Button>
                    </div> */}
                    {props.selectedRowKeys}
                </div>

            </Modal>
        </>
    )
}